import React from 'react';
import Button from '@mui/material/Button';

const ButtonHaver = ({ row }) => {
  // Replace with your actual button logic
  return (
    <Button variant="contained" color="primary">
      Action
    </Button>
  );
};

export default ButtonHaver;
